// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.2803 2H1.71875L2.99071 7.08782L1.92555 22H14V17H16V22H21.9995V13.382L14.9995 9.88197L12.3683 11.1976L12.0103 7.08014L13.2803 2ZM4.0735 20L4.93065 8H10.0827L10.4444 12.1595L7.99953 13.382V20H4.0735ZM10.7188 4L10.2188 6H4.7803L4.2803 4H10.7188Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chimney-filled')
export default class ChimneyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chimney-filled',
    }
  }
}
